var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('TableItemComponent',{class:{ 'disabled-row': !_vm.row.enabled },attrs:{"item":_vm.row,"columns":_vm.columns,"index":_vm.index}})
}
var staticRenderFns = []

export { render, staticRenderFns }